
import NewVisitorList from "../NewVisitorList/NewVisitorList";

const VisitorList = () => {
	return <NewVisitorList />;
};

export default VisitorList;
